import { useEffect, useState } from "react";
import { Link/*, useNavigate*/ } from "react-router-dom";
import { useLoading } from "../../Context/LoadingProvider";
import { useUser } from "../../Context/UserProvider";
import { useTranslation } from "react-i18next";
import { weeklyStockCheckService } from "../../Api/Services/WeeklyStockCheckService";
import { StockModel } from "../../Api/Models/stock.model";

import { MopedIcon } from "../../Components/Icons/MopedIcon"; 
import { BagIcon } from "../../Components/Icons/BagIcon";
import { BookIcon} from "../../Components/Icons/BookIcon";
import UserNavigation from "../UserNavigation";

import TalabatLogo from "../../Assets/gfx/boolanga_bi.png";
import DailyInfo from "../../Components/DailyInfo";
import {stockService} from "../../Api/Services/StockService";

import { useNavigate } from "react-router-dom";

interface FunctionsMenuProps {}

const FunctionsMenu: React.FunctionComponent<FunctionsMenuProps> = () => {
  const navigate = useNavigate();
  const { startLoading, finnishLoading } = useLoading();
  const { user } = useUser();
  //const [showQrReader, setShowQrReader] = useState<boolean>(false);
  const { t } = useTranslation();

  const [stockCheckComplete, setStockCheckComplete] = useState<boolean | null>(null);

  function askPermission() {
    return new Promise(function (resolve, reject) {
      const permissionResult = Notification.requestPermission(function (
        result
      ) {
        resolve(result);
      });

      if (permissionResult) {
        permissionResult.then(resolve, reject);
      }
    }).then(function (permissionResult) {
      if (permissionResult !== "granted") {
        console.log("We weren't granted permission.");
      }
    });
  }

  const fetchWeeklyComplete = async () => {
    startLoading("fetch-weekly-stock-check-complete");
    weeklyStockCheckService
      .thisWeekComplete()
      .then((result) => {
        setStockCheckComplete(result.complete);
      })
      .finally(() => finnishLoading("fetch-weekly-stock-check-complete"));
  };

  useEffect(() => {
    askPermission();
    fetchWeeklyComplete();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (stockCheckComplete === false) {
      navigate("/stock/weekly-stock-check");
    }
  }, [stockCheckComplete, navigate]);

  const [stocks, setStocks] = useState<StockModel[]>([]);

  useEffect(() => {
    loadStocks();
    //eslint-disable-next-line
  }, []);

  const loadStocks = () => {
    startLoading("get-stock-list");
    stockService
        .listStocks()
        .then((stocks) => {
          setStocks(stocks);
        })
        .finally(() => {
          finnishLoading("get-stock-list");
        });
  };

  const totalQuantity = stocks.reduce((total, stock) => total + stock.quantity, 0);
  /*const closeQrReaderModal = () => {
    setShowQrReader(false);
  };*/

  return (
    <div className="view-container view-container--stretch background">
      <div className="view-content h-full flex flex-col justify-between">
        <div>
          <div className="navigationbar mb-6">
            <div className="navigationbar__left"></div>
            <div className="navigationbar__center">
              <img src={TalabatLogo} width="95" height="20" style={{minWidth: '95px'}} alt="Talabat" />
            </div>
            <div className="navigationbar__right">
              <UserNavigation />
            </div>
          </div>

          <DailyInfo />
          
        </div>

        {/*
        <LanguageSelector />

        <QrReaderModal show={showQrReader} close={closeQrReaderModal} />
        <div className="flex justify-center">
          <div className="scan-qr bg-white rounded-xl mb-8">
            <div
              className="scan-qr__image"
              onClick={() => setShowQrReader(true)}
            >
              <div className="scan-qr__corners">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <img src={QrCodeImage} alt="Qr reader" />
            </div>
            <div className="scan-qr__text">{t("scan qr")}</div>
          </div>
        </div>
              */}
        
          
          

          <div className="card-list card-list--gap-10 mt-6">
            <div className="heading text-white font-300">
              {t("Menu")}
            </div>

            <Link
              to={stockCheckComplete ? "/rider/search" : "#"}
              className={
                "nav-card " + (!stockCheckComplete ? "nav-card_disabled" : "")
              }
            >
              {/*
              <img
                src={OrderListIcon}
                className="nav-card__icon"
                alt="Rider search"
              />
              */}

              <div className="rounded-icon">
                <MopedIcon/>
              </div>
              <div className="nav-card__title">{t("Rider Search")}</div>
            </Link>

            {/*
            <Link to="/orders/list" className="nav-card">
              <img
                src={OrderListIcon}
                className="nav-card__icon"
                alt="Order list"
              />
              <div className="nav-card__title">{t("Order list")}</div>
            </Link>

            <Link to="/return/list" className="nav-card">
              <img
                src={ReturnListIcon}
                className="nav-card__icon"
                alt="Return list"
              />
              <div className="nav-card__title">{t("Return list")}</div>
            </Link>

            <Link to="/warranty/list" className="nav-card">
              <img
                src={ExchangeListIcon}
                className="nav-card__icon"
                alt="Exchange list"
              />
              <div className="nav-card__title">{t("Exchange list")}</div>
            </Link>
            */}
            {!user?.permissions?.includes("app_user.view_only") ? (
              <>
                <Link to="/stock/list" className="nav-card">
                  {/*
                  <img
                    src={StockList}
                    className="nav-card__icon"
                    alt="Stock list"
                  />
                  */} 

                  <div className="rounded-icon">
                    <div className="rounded-icon__badge">{(totalQuantity < 100 ? totalQuantity : '99+')}</div>
                    <BagIcon/>
                  </div>

                  
                  <div className="nav-card__title">{t("Stock")}</div>
                </Link>

                {/*<Link to="/sanitization/list" className="nav-card">
                  <img
                    src={Sanitization}
                    className="nav-card__icon"
                    alt="Sanitizazion list"
                  />
                  <div className="nav-card__title">{t("Sanitization")}</div>
                </Link>*/}
              </>
            ) : null}

            {/*
            <Link to="/new-kit/list" className="nav-card">
              <img src={NewKit} className="nav-card__icon" alt="New Kit list" />
              <div className="nav-card__title">{t("New kit")}</div>
            </Link>
            */}
            <Link
                to={stockCheckComplete ? "/appointments/my" : "#"}
                className={
                    "nav-card " + (!stockCheckComplete ? "nav-card_disabled" : "")
                }
            >
              {/*
              <img
                src={OrderListIcon}
                className="nav-card__icon"
                alt="Rider search"
              />
              */}

              <div className="rounded-icon">
                <BookIcon/>
              </div>
              <div className="nav-card__title">{t("Appointments")}</div>
            </Link>
            
          </div>
        
      </div>
    </div>
  );
};

export default FunctionsMenu;
